import React, { Component } from 'react';
import axios from 'axios';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from 'react-router-dom';
import { sortBy, find } from 'lodash';
import moment from 'moment';
// material
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Container } from '@material-ui/core';
// app
import { updateSession, setApiUrls, addAuth, openSnackbar, closeSnackbar } from '../../store/action-creators';
// containers
import AdminContainer from '../../containers/Admin';
// models
import { Auth, Session } from '../../entities/auth';
import { APIUrl, CampaignContact } from '../../entities/site';
import { Address } from '../../entities/home';
// components
import Loading from '../../components/site/Loading';
import DropContacts from '../../components/campaign/DropContacts';
import { SelectItem } from '../../components/inputs/SelectInput';
import CampaignContactHeaders, { MappedHeader } from '../../components/campaign/CampaignContactHeaders';
import CampaignContactsList from '../../components/campaign/CampaignContactsList';
import ActionButton from '../../components/buttons/ActionButton';
// services
import AuthService from '../../services/auth';
import CampaignService from '../../services/campaign';

const useProd = true;

const styles: any = {
  tableWrapper: {
    maxHeight: 440,
    overflow: 'auto',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: 'left'
  }
}

interface AdminPageProps {
  history: any;
  auth: Auth;
  session: Session;
  apiUrls: APIUrl;
  updateSession(session: Session): void;
  setApiUrls(urls: APIUrl): void;
  openSnackbar(message: string): void;
  closeSnackbar(): void;
}

interface AdminPageState {
  loading: boolean;
  totalContacts: number;
  contactChunks: [];
  contactErrors: CampaignContact[];
  addresses: Address[];
  fileData: any;
  headers: string[];
  uploadHeaders: SelectItem[];
  mappedHeaders: MappedHeader[];
  showMappedHeaders: boolean;
  contactListTitle: string;
  contactListType: string;
  showContactList: boolean;
  campaignContacts: CampaignContact[];
}

class AdminAddressesPage extends Component<AdminPageProps, AdminPageState> {

  constructor(props: AdminPageProps) {
    super(props);
    this.state = {
      loading: false,
      addresses: [],
      fileData: null,
      headers: [],
      uploadHeaders: [],
      mappedHeaders: [],
      showMappedHeaders: false,
      totalContacts: 0,
      contactChunks: [],
      contactErrors: [],
      contactListTitle: '',
      contactListType: '',
      showContactList: false,
      campaignContacts: []
    }
  }

  componentDidMount = async () => {
    // if (!this.isAdmin()) {
    //   this.props.history.push('/');
    // }
    this.fetchAddresses();
  }

  fetchAddresses = async () => {
    this.setState({ loading: true });
    const addresRes = await axios.get(`${AuthService.getApiUrls().home}/addresses`);
    this.setState({
      addresses: sortBy(addresRes.data, ['createdDate']).reverse(),
      loading: false
    });
  }

  handleFileDrop = async (data: any) => {

    try {

      // get headers
      const parseHeaderRes = await axios.post(`${AuthService.getApiUrls().site}/campaign/contacts/parse/headers`, { file: data });

      if (parseHeaderRes.data.errorMessage) {
        throw parseHeaderRes.data.errorMessage;
      }
      const headersArray = parseHeaderRes.data;
      const headerItems: SelectItem[] = [
        {
          name: 'Empty Column',
          value: 'empty'
        }
      ];
      headersArray.forEach((header: string) => {
        headerItems.push({
          name: header,
          value: header
        })
      });

      this.setState({
        fileData: data,
        headers: headersArray,
        uploadHeaders: headerItems,
        showMappedHeaders: true
      });

    } catch (error) {
      console.log('error', error);
    }

  }

  handleContactsClick = (type: string) => {
    let contactList: CampaignContact[] = [];
    let contactListTitle = 'Valid Contacts';
    if (type === 'contacts') {
      // loop through the chunks
      this.state.contactChunks.forEach((chunk: CampaignContact[]) => {
        chunk.forEach((contact: CampaignContact) => {
          contactList.push(contact);
        });
      })
    } else {
      contactListTitle = 'Contacts Missing Required Data';
      contactList = this.state.contactErrors;
    }
    this.setState({
      contactListTitle,
      contactListType: type,
      showContactList: true,
      campaignContacts: contactList
    });
  }

  handleHeaderClose = async (mapped: MappedHeader[]) => {

    this.setState({ showMappedHeaders: false });

    if (!mapped.length) {
      // show error
      return;
    }

    const mappedNew: MappedHeader[] = [];
    CampaignService.getSupportedColumns().forEach((supportedColumn: string) => {

      const search = find(mapped, { supportedColumn })
      if (search) {
        search.index = this.state.headers.indexOf(search.column);
        mappedNew.push(search);
      } else {
        mappedNew.push({
          supportedColumn,
          column: '',
          index: -1
        });
      }
    });

    this.setState({ mappedHeaders: mappedNew });

    // parse again with mapped columns
    const fileDataBody = {
      file: this.state.fileData,
      cols: mappedNew
    };
    const parseRes = await axios.post(`${AuthService.getApiUrls().site}/campaign/contacts/parse`, fileDataBody);
    if (parseRes.data) {
      this.setState({
        totalContacts: parseRes.data.rows,
        contactChunks: parseRes.data.chunks,
        contactErrors: parseRes.data.errors
      });
    }

  }

  handleCampaignContactListClose = () => {
    this.setState({
      showContactList: false
    });
  }

  handleImport = async () => {

    try {
      // save campaign contacts
      const flatten = [].concat.apply([], this.state.contactChunks);
      const contactData = {
        chucks: flatten
      };

      await axios.post(`${AuthService.getApiUrls().site}/campaign/contacts/addresses/import`, contactData);

    } catch (error) {
      console.log('error', error);
    }

  }

  render() {

    return (
      <AdminContainer showOption={false} private={false} maxWidth={false}>
        <Loading open={this.state.loading} />
        <Container maxWidth="lg">
          <div style={styles.title}>Addresses</div>
          <DropContacts
            onDrop={this.handleFileDrop}
            onClick={this.handleContactsClick}
            total={this.state.totalContacts}
            errors={this.state.contactErrors.length}
          />
          <CampaignContactsList
            open={this.state.showContactList}
            title={this.state.contactListTitle}
            campaignContacts={this.state.campaignContacts}
            onClose={this.handleCampaignContactListClose}
          />
          <CampaignContactHeaders
            open={this.state.showMappedHeaders}
            headers={this.state.uploadHeaders}
            onClose={this.handleHeaderClose}
          />
          {(this.state.totalContacts > 0) &&
            <ActionButton name="Import Contact Addresses" size="sm" onClick={this.handleImport} fullWidth />
          }
          <Paper>
            <div style={styles.tableWrapper}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Key</TableCell>
                    <TableCell>Address</TableCell>
                    <TableCell>Estimate</TableCell>
                    <TableCell>Loan Balance</TableCell>
                    <TableCell>Baths</TableCell>
                    <TableCell>Beds</TableCell>
                    <TableCell>Sqr Ft</TableCell>
                    <TableCell>Created</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.addresses.map((address, index) => (
                    <TableRow key={`address-${index}`}>
                      <TableCell component="th" scope="row">{address.id}</TableCell>
                      <TableCell>{address.address}</TableCell>
                      <TableCell>{address.estimate}</TableCell>
                      <TableCell>{address.loanBalance}</TableCell>
                      <TableCell>{address.baths}</TableCell>
                      <TableCell>{address.beds}</TableCell>
                      <TableCell>{address.sqft}</TableCell>
                      <TableCell>{moment(address.createdDate).format('MM-DD-YYYY HH:MM')}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Paper>
        </Container>
      </AdminContainer>
    )
  }


}

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth.auth,
    session: state.session.session,
    apiUrls: state.site.apiUrls
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return bindActionCreators({ updateSession, setApiUrls, addAuth, openSnackbar, closeSnackbar }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter<any, any>(AdminAddressesPage));



// WEBPACK FOOTER //
// ./src/pages/admin/AdminAddresses.tsx